export default "__VITE_ASSET__BORdY_wD__"